import { createRouter, createWebHistory } from 'vue-router';
import store from './store' // adjust path as per your project

import NotFound from './pages/NotFound.vue';
import Login from './pages/users/Login.vue';
import Registration from './pages/users/Registration.vue'; 
import Orders from './pages/orders/Orders.vue';
import Token from './pages/users/Token.vue';
import Home from './pages/home/Home.vue';
import Positions from './pages/positions/Positions.vue';
import Trades from './pages/trades/Trades.vue';
import TradeView from './pages/trades/TradeView.vue';
import PastTrades from './pages/trades/PastTrades.vue'; 
import PortfolioStrategy from './pages/strategy/PortfolioStategy.vue';
import NewTrades from './pages/trades/NewTrades.vue';
import PortfolioList from './pages/portfolio/PortfolioList.vue';
import PortfolioDetail from './pages/portfolio/PortfolioDetail.vue';
import CoveredCallList from './pages/coveredcall/CoveredCallList.vue';
import CoveredCallDetails from './pages/coveredcall/CoveredCallDetails.vue';
import CoveredCallNew from './pages/coveredcall/CoveredCallNew.vue';
import Mf from './pages/mf/Mf.vue';
import MfDetails from './pages/mf/MfDetails.vue';
import MfBucket from './pages/mf/MfBucket.vue';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/home' },
    { path: '/user/login', component: Login },
    { path: '/user/registration', component: Registration },
    { path: '/orders', component: Orders },
    { path: '/user/token', component: Token },
    { path: '/home', component: Home },
    { path: '/positions', component: Positions },
    { path: '/trades', component: Trades },
    { path: '/portfolio/portfolioList', component: PortfolioList },
    { path: '/portfolio/portfolioDetail', component: PortfolioDetail },
    { path: '/trades/tradeView', component: TradeView },
    { path: '/trades/pastTrades', component: PastTrades },
    { path: '/trades/newTrades', component: NewTrades },
    { path: '/strategy/portfolioStrategy', component: PortfolioStrategy },
    { path: '/mf', component: Mf },
    { path: '/mf/details', component: MfDetails },
    { path: '/mf/bucket', component: MfBucket },
    { path: '/coveredcall/CoveredCallList', component: CoveredCallList },
    { path: '/coveredcall/CoveredCallDetails', component: CoveredCallDetails },
    { path: '/coveredcall/CoveredCallNew', component: CoveredCallNew },
    { path: '/:notFound(.*)', component: NotFound }
  ]
});

router.beforeEach((to, from, next) => {
  const publicPages = ['/user/login', '/user/registration'];
  const isPublic = publicPages.includes(to.path);
  const isLoggedIn = store.state.users.isLoggedIn;

  if (!isPublic && !isLoggedIn) {
    next('/user/login');
  } else {
    next();
  }
});

export default router;
